"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TaskType = void 0;
var _react = require("react");
var _hooks = require("../../../../../hooks");
var _Select = require("../../../../../UI/Select");
var _useItem2 = require("../../../hooks/useItem");
var _TaskManager = require("../../../TaskManager.provider");
var _SectionLabel = require("../SectionLabel");
var _SectionDescription = require("../SectionDescription");
var _TaskType = _interopRequireDefault(require("./TaskType.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var TaskType = function TaskType(props) {
  var _task$item;
  var itemID = props.itemID,
    taskID = props.taskID,
    itemLanguage = props.itemLanguage,
    environmentID = props.environmentID,
    audienceID = props.audienceID,
    kotarParams = props.kotarParams,
    isChangeAudienceAfterSubmitEnabled = props.isChangeAudienceAfterSubmitEnabled,
    isLearningActivity = props.isLearningActivity,
    isSelfLearningEnabled = props.isSelfLearningEnabled,
    isTaskTypeChangeEnabled = props.isTaskTypeChangeEnabled,
    isScheduleOnlyExam = props.isScheduleOnlyExam,
    minDate = props.minDate,
    maxDate = props.maxDate;
  var _useContext = (0, _react.useContext)(_TaskManager.TaskManagerContext),
    task = _useContext.task,
    setTask = _useContext.setTask,
    originalTask = _useContext.originalTask,
    unitData = _useContext.unitData,
    setIsChanged = _useContext.setIsChanged,
    getLabel = _useContext.getLabel,
    isChangedBackToExam = _useContext.isChangedBackToExam,
    setIsChangedBackToExam = _useContext.setIsChangedBackToExam;
  var _useItem = (0, _useItem2.useItem)(itemID, itemLanguage, environmentID, audienceID, taskID, kotarParams, minDate, maxDate, isChangeAudienceAfterSubmitEnabled, isLearningActivity),
    getTaskTiming = _useItem.getTaskTiming;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    taskTypes = _useState2[0],
    setTaskTypes = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedOption = _useState4[0],
    setSelectedOption = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    taskTypeDescription = _useState6[0],
    setTaskTypeDescription = _useState6[1];
  var styles = (0, _TaskType.default)();
  var isNoCheckItem = task === null || task === void 0 ? void 0 : (_task$item = task.item) === null || _task$item === void 0 ? void 0 : _task$item.showMessage;
  var isTaskTypeCanNotChange = (task === null || task === void 0 ? void 0 : task.cannotModifyMembers) && !isTaskTypeChangeEnabled;
  var handleSelectOption = function handleSelectOption(option) {
    setSelectedOption(option);
    if (option.value !== (task === null || task === void 0 ? void 0 : task.taskType)) {
      setIsChanged(true);
      var _getTaskTiming = getTaskTiming(option.value.toString(), task.startDateTime, undefined),
        startDateTime = _getTaskTiming.startDateTime,
        endDateTime = _getTaskTiming.endDateTime,
        publishDate = _getTaskTiming.publishDate,
        feedbackDate = _getTaskTiming.feedbackDate,
        feedbackType = _getTaskTiming.feedbackType;
      setTask(_objectSpread(_objectSpread({}, task), {}, {
        taskType: option.value,
        startDateTime: startDateTime,
        endDateTime: endDateTime,
        publishDate: publishDate,
        feedbackDate: feedbackDate,
        feedbackType: feedbackType
      }));
    }
  };
  (0, _react.useEffect)(function () {
    if (unitData !== null && unitData !== void 0 && unitData.taskTypes) {
      var currentTaskTypes = Object.keys(unitData.taskTypes).filter(function (key) {
        var _task$item2;
        var addIt = false;
        switch (key) {
          case 'analysis':
            if (task !== null && task !== void 0 && (_task$item2 = task.item) !== null && _task$item2 !== void 0 && _task$item2.isAnalysis && !isNoCheckItem) {
              addIt = true;
            }
            break;
          case 'selfLearning':
            if (isSelfLearningEnabled) {
              addIt = true;
            }
            break;
          case 'evalWork':
            if (!isNoCheckItem) {
              addIt = true;
            }
            break;
          case 'learningWork':
            addIt = true;
            break;
          case 'exam':
            if (task !== null && task !== void 0 && task.cannotModifyMembers && (originalTask === null || originalTask === void 0 ? void 0 : originalTask.taskType) !== 'exam') {
              addIt = false;
            } else {
              if (!isNoCheckItem) {
                addIt = true;
              }
            }
            break;
          default:
            addIt = true;
            break;
        }
        return addIt;
      });
      if (isSelfLearningEnabled) {
        var index = currentTaskTypes.indexOf('selfLearning');
        if (index > -1) {
          currentTaskTypes.splice(index, 1);
        }
        currentTaskTypes.unshift('selfLearning');
      }
      var taskTypesData = currentTaskTypes.map(function (taskType) {
        return {
          value: taskType,
          label: unitData === null || unitData === void 0 ? void 0 : unitData.taskTypes[taskType]
        };
      });
      setTaskTypes(taskTypesData);
    }
  }, [isLearningActivity, isNoCheckItem, isSelfLearningEnabled, originalTask === null || originalTask === void 0 ? void 0 : originalTask.taskType, task, unitData === null || unitData === void 0 ? void 0 : unitData.taskTypes]);
  (0, _react.useEffect)(function () {
    if (isChangedBackToExam) {
      setTask(_objectSpread(_objectSpread({}, task), {}, {
        taskType: 'exam',
        startDateTime: originalTask === null || originalTask === void 0 ? void 0 : originalTask.startDateTime,
        endDateTime: originalTask === null || originalTask === void 0 ? void 0 : originalTask.endDateTime,
        publishDate: originalTask === null || originalTask === void 0 ? void 0 : originalTask.publishDate,
        feedbackDate: originalTask === null || originalTask === void 0 ? void 0 : originalTask.feedbackDate,
        feedbackType: originalTask === null || originalTask === void 0 ? void 0 : originalTask.feedbackType
      }));
      setIsChangedBackToExam(false);
    }
  }, [isChangedBackToExam, originalTask === null || originalTask === void 0 ? void 0 : originalTask.endDateTime, originalTask === null || originalTask === void 0 ? void 0 : originalTask.feedbackDate, originalTask === null || originalTask === void 0 ? void 0 : originalTask.feedbackType, originalTask === null || originalTask === void 0 ? void 0 : originalTask.publishDate, originalTask === null || originalTask === void 0 ? void 0 : originalTask.startDateTime, setIsChangedBackToExam, setTask, task]);
  (0, _react.useEffect)(function () {
    if (task !== null && task !== void 0 && task.taskType) setSelectedOption({
      value: task === null || task === void 0 ? void 0 : task.taskType,
      label: unitData === null || unitData === void 0 ? void 0 : unitData.taskTypes[task === null || task === void 0 ? void 0 : task.taskType]
    });
  }, [task === null || task === void 0 ? void 0 : task.taskType, unitData === null || unitData === void 0 ? void 0 : unitData.taskTypes]);
  (0, _react.useEffect)(function () {
    var description = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) === 'learningWork' ? getLabel('text_label_taskTypeDescription_learningWork') : (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) === 'evalWork' ? getLabel('text_label_taskTypeDescription_evalWork') : (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) === 'exam' ? getLabel('text_label_taskTypeDescription_exam') : '';
    setTaskTypeDescription(description);
  }, [getLabel, selectedOption]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-TaskManager__task-type'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionLabel.SectionLabel, {
      text: getLabel('text_label_activityType'),
      isDisabled: task && (task.isReadOnly || isTaskTypeCanNotChange || (taskTypes === null || taskTypes === void 0 ? void 0 : taskTypes.length) <= 1 || isScheduleOnlyExam)
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-TaskManager__task-type-select-and-description'],
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.Select, {
        value: selectedOption,
        onChange: handleSelectOption,
        anchorWidth: isMobileView ? 'auto' : 'fit-content',
        btnProps: {
          color: 'basic',
          view: 'outlined',
          customStyle: {
            width: isMobileView ? '100%' : pxToRem(180)
          },
          shape: isMobileView ? 'roundedRectangle' : 'ellipse',
          isDisabled: task && (task.isReadOnly || isTaskTypeCanNotChange || (taskTypes === null || taskTypes === void 0 ? void 0 : taskTypes.length) <= 1 || isScheduleOnlyExam)
        },
        options: taskTypes
      }), taskTypeDescription && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionDescription.SectionDescription, {
        text: taskTypeDescription
      })]
    })]
  });
};
exports.TaskType = TaskType;